import type { LucideIcon } from 'lucide-react'
import type { ReactNode } from 'react'
import { cn } from '@/lib/utils'

export function EmptyState({
  icon: Icon,
  title,
  description,
  action,
  className,
  compact = false,
}: {
  icon?: LucideIcon
  title: string
  description?: ReactNode
  action?: ReactNode
  className?: string
  compact?: boolean
}) {
  return (
    <div className={cn('flex flex-col items-center justify-center text-center', compact ? 'gap-2 px-4 py-8' : 'gap-3 px-6 py-14', className)}>
      {Icon && (
        <div className="relative">
          <div className="absolute inset-0 rounded-2xl bg-brand-gradient opacity-20 blur-xl" aria-hidden />
          <div className={cn('relative flex items-center justify-center rounded-2xl border bg-card shadow-sm', compact ? 'size-10' : 'size-12')}>
            <Icon className={cn('text-primary', compact ? 'size-5' : 'size-6')} strokeWidth={1.75} />
          </div>
        </div>
      )}
      <div className="max-w-sm space-y-1">
        <p className={cn('font-semibold', compact ? 'text-sm' : 'text-[15px]')}>{title}</p>
        {description && <p className="text-[13px] text-muted-foreground">{description}</p>}
      </div>
      {action && <div className="pt-1">{action}</div>}
    </div>
  )
}
